<script setup lang="ts">
import Badge from '#components/badge/Badge.vue';
import FilterTooltip from '#components/filterTooltip/FilterTooltip.vue';
import PopOver from '#components/popover/PopOver.vue';
import { computed, ref, type PropType } from 'vue';

const props = defineProps({
  items: { type: Array as PropType<string[]>, required: true },
  visibleItemCount: { type: Number, default: 3 },
  tooltipTitle: { type: String, default: '' }
});

const popoverStatus = ref<'hidden' | 'visible' | 'none'>('none');

const itemsRef = computed(() => props.items);

const visibleItemsText = computed(() => {
  return itemsRef.value.slice(0, props.visibleItemCount).join(', ');
});

const handleEnter = () => {
  if (itemsRef.value.length > props.visibleItemCount) {
    popoverStatus.value = 'visible';
  }
};

const handleLeave = () => {
  popoverStatus.value = 'hidden';
};
</script>

<template>
  <PopOver :show="popoverStatus" class-name="z-0!" position="bottom">
    <div class="flex">
      <div class="flex flex-wrap gap-x-2" @mouseenter="handleEnter" @mouseleave="handleLeave">
        <span class="wrap-break-word after:font-normal not-last:after:content-[',']">
          {{ visibleItemsText }}
        </span>
        <Badge
          v-if="itemsRef.length > visibleItemCount"
          :value="itemsRef.length - visibleItemCount"
          :disabled="true"
          variant="strong"
        />
      </div>
    </div>
    <template #content>
      <FilterTooltip :values="items" :title="tooltipTitle" @mouseleave="handleLeave" @mouseenter="handleEnter"
    /></template>
  </PopOver>
</template>
